import { useEffect, useState } from 'react';
import XCircularProgress from '../common/XCircularProgress';
import RenderIf from '../render-if/Renderif';
import { getLoadingPercentage } from '../../utils/helper';

const progressCellClasses = 'align-middle text-center';

const progressWrapperClasses = 'inline-flex flex-col items-center justify-center gap-1';

const statusMessageClasses = 'text-xs text-muted max-w-[10rem]';

// a blocked draft has to read differently from an untouched one, so its reason is legible rather than muted
const reviewMessageClasses = 'text-xs font-medium text-warning max-w-[14rem]';

const CaseStatusCell = ({
    updateTime,
    isSuccessful,
    isFailed,
    isDraft,
    statusMessage,
}) => {
    const [progress, setProgress] = useState(getLoadingPercentage(updateTime));
    const [loadingValue, setLoadingValue] = useState(isSuccessful || isFailed ? 100 : progress);

    useEffect(() => {
        if (isSuccessful || isFailed) return;

        const interval = setInterval(() => {
            setProgress(getLoadingPercentage(updateTime));
        }, 10 * 1000);

        return () => clearInterval(interval);
    }, [updateTime, isSuccessful, isFailed]);

    useEffect(() => {
        const lv = isSuccessful || isFailed ? 100 : progress;

        const clamped = Math.max(0, Math.min(100, lv));
        setLoadingValue(clamped);
    }, [progress, isSuccessful, isFailed]);

    if (isDraft) {
        // statusMessage is only set when a blocking gap stopped the run, so its presence is what tells a
        // reviewed-but-blocked case apart from one nobody has opened
        const needsReview = Boolean(statusMessage);

        return (
            <td className={progressCellClasses}>
                <div className={progressWrapperClasses}>
                    <div>{needsReview ? 'Needs review before demand' : 'This is a draft Case'}</div>

                    <RenderIf shouldRender={needsReview}>
                        <span className={reviewMessageClasses}>{statusMessage}</span>
                    </RenderIf>
                </div>
            </td>
        );
    }

    return (
        <td className={progressCellClasses}>
            <div className={progressWrapperClasses}>
                <XCircularProgress
                    value={loadingValue}
                    isFailed={isFailed}
                />

                <RenderIf shouldRender={Boolean(statusMessage)}>
                    <span className={statusMessageClasses}>{statusMessage}</span>
                </RenderIf>
            </div>
        </td>
    );
};

export default CaseStatusCell;
